export const removeTrailingSlash = (str?: string) => (str ? str.replace(/\/$/, '') : '');
export const removeLeadingSlash = (str?: string) => (str ? str.replace(/^\//, '') : '');
export const removeEnclosingSlashes = (str?: string) => (str ? str.replace(/^\/|\/$/g, '') : '');
export const normalizePath = (path?: string) => `${removeEnclosingSlashes(path ?? '').replace(/[^a-z0-9-_/?]/gi, '')}`;
export const normalizePathForPage = (path?: string) => `/${normalizePath(path)}`;
